import { call } from "@saas/api-client";
import {
  Card,
  DescriptionList,
  ErrorAlert,
  formatDate,
  Loading,
  PageHeader,
  useAsync,
} from "@saas/ui";
import { api } from "./api";

export function DashboardPage() {
  // Recording the sign-in accepts the invitation on first visit. Then load profile, tenant and health.
  const profile = useAsync(async () => {
    await api.POST("/api/me/sign-ins");
    return call(api.GET("/api/me"));
  }, []);
  const tenant = useAsync(() => call(api.GET("/api/my-tenant")), []);

  return (
    <>
      <PageHeader title={`Welcome${profile.data?.displayName ? `, ${profile.data.displayName}` : ""}`} description={tenant.data ? `You are working in ${tenant.data.displayName}.` : undefined} />
      <HealthPanel />
      <div className="sb-grid">
        <Card title="You">
          <ErrorAlert error={profile.error} />
          {profile.data ? (
            <DescriptionList
              items={[
                ["Signed in as", <span key="e" data-testid="profile-email">{profile.data.email}</span>],
                ["Tenant", <span key="t" data-testid="profile-tenant">{tenant.data?.displayName ?? profile.data.tenantName ?? "—"}</span>],
                ["Role", <span key="r" data-testid="profile-role">{profile.data.roles.join(", ") || "none"}</span>],
                ["Membership", profile.data.membershipStatus ?? "—"],
                ["Identity realm", profile.data.realm],
              ]}
            />
          ) : (
            <Loading />
          )}
        </Card>
      </div>
    </>
  );
}

function HealthPanel() {
  const status = useAsync(() => call(api.GET("/api/status")), [], 15000);
  if (status.loading && !status.data) return <Loading label="Checking the platform…" />;
  const ok = status.data?.status === "ok";
  return (
    <section aria-labelledby="health-heading" className={`sb-health ${ok ? "sb-health--ok" : "sb-health--bad"}`} data-testid="health">
      <div>
        <h2 id="health-heading" className="sb-muted" style={{ fontSize: "var(--text-sm)" }}>
          Platform status
        </h2>
        <strong data-testid="health-status">{ok ? "The SaaS is up and running" : "The SaaS is degraded"}</strong>
        {status.data ? (
          <ul className="sb-steps" aria-label="End-to-end checks">
            <li>Browser → BFF: OK</li>
            <li>· BFF → API: {status.data.api.toUpperCase()}</li>
            <li>
              · API → PostgreSQL: {status.data.database === "ok" ? "OK" : status.data.database} ({status.data.databaseLatencyMs} ms)
            </li>
            <li>· Checked {formatDate(status.data.checkedAt)}</li>
          </ul>
        ) : (
          <p>{status.error?.message}</p>
        )}
      </div>
    </section>
  );
}

